import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const MonthlyLeaveChart = ({ data }) => {
     // Transform data for chart
     const chartData = data.reduce((acc, item) => {
          const date = new Date(item.date).getDate();
          const existing = acc.find(d => d.date === date);

          if (existing) {
               existing[item.leave_type] = (existing[item.leave_type] || 0) + parseFloat(item.days || 0);
          } else {
               acc.push({
                    date,
                    [item.leave_type]: parseFloat(item.days || 0)
               });
          }

          return acc;
     }, []);

     // Sort by date
     chartData.sort((a, b) => a.date - b.date);

     const CustomTooltip = ({ active, payload, label }) => {
          if (active && payload && payload.length) {
               return (
                    <div className="bg-white p-3 border rounded shadow-sm">
                         <p className="mb-2"><strong>Date: {label}</strong></p>
                         {payload.map((entry, index) => (
                              <p key={index} className="mb-1" style={{ color: entry.color }}>
                                   {entry.name}: {entry.value} day(s)
                              </p>
                         ))}
                    </div>
               );
          }
          return null;
     };

     return (
          <div className="chart-container">
               <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                         data={chartData}
                         margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    >
                         <CartesianGrid strokeDasharray="3 3" />
                         <XAxis
                              dataKey="date"
                              label={{ value: 'Day of Month', position: 'insideBottom', offset: -5 }}
                         />
                         <YAxis
                              label={{ value: 'Days', angle: -90, position: 'insideLeft' }}
                         />
                         <Tooltip content={<CustomTooltip />} />
                         <Legend />
                         <Bar dataKey="PL" fill="#0d6efd" name="Privilege Leave" />
                         <Bar dataKey="CL" fill="#198754" name="Casual Leave" />
                         <Bar dataKey="SL" fill="#ffc107" name="Sick Leave" />
                    </BarChart>
               </ResponsiveContainer>
          </div>
     );
};

export default MonthlyLeaveChart;